import { navigate } from "gatsby";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import {responsiveproductlistmobile}  from "../../../../utils/constant";

let responsiveproductlistmobile2 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };
  let responsiveproductlistmobile3 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
  let responsiveproductlistmobile4 = {
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 4
    }
  };
const Layout_1 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div id="danh-muc" className="row menu-home-second mgt-5 pdx-5 bg-white">
            {
                item.length>0?(
                    <Carousel key="category"
                    responsive={responsiveproductlistmobile2}
                    >
                    {
                        item.map((item, i)=>{
                            return <div key={i} >
                                <div className='row mgx-0'>
                                    <img onClick={()=>handleClick(item.uri)} src={item.images} alt={item.name}/>
                                </div>
                            </div>
                        })
                    }
                    </Carousel>
                    
                ):(null)
            }
        </div>
    )
}
const Layout_2 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div id="danh-muc" className="row  menu-home-second mgt-5 pdx-5  bg-white">
            {
                item.length>0?(
                    <Carousel key="category"
                    responsive={responsiveproductlistmobile3}
                    >
                    {
                        item.map((item, i)=>{
                            return <div key={i} >
                                <div className='row mgx-0'>
                                    <img onClick={()=>handleClick(item.uri)} src={item.images} alt={item.name}/>
                                </div>
                            </div>
                        })
                    }
                    </Carousel>
                    
                ):(null)
            }
        </div>
    )
}
const Layout_3 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div id="danh-muc" className="row  menu-home-second mgt-5 pdx-5 bg-white">
            {
                item.length>0?(
                    <Carousel key="category"
                    responsive={responsiveproductlistmobile4}
                    >
                    {
                        item.map((item, i)=>{
                            return <div key={i} >
                                <div className='row mgx-0'>
                                    <img onClick={()=>handleClick(item.uri)} src={item.images} alt={item.name}/>
                                </div>
                            </div>
                        })
                    }
                    </Carousel>
                    
                ):(null)
            }
        </div>
    )
}

export {Layout_1,Layout_2,Layout_3}